module.exports = __webpack_public_path__ + "img/park.2a9e8bba.svg";